import React from 'react';

const Booking: React.FC = () => {
  return (
    <div className="pt-20">
      <section className="py-20 bg-black text-white min-h-[60vh] flex items-center">
        <div className="section-padding text-center w-full">
          <h1 className="font-serif text-5xl md:text-6xl mb-6">Book Your Session</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-10">
            Ready to create something beautiful? Click below to book your session with us.
          </p>
          <a
            href="https://app.somapix.com/profile/graphiczonestudio"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-lg px-12 py-4"
          >
            Book Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default Booking;
